import App from '../../components/App';
import props from '../../configs/propsRecent';

export default function FontGenerator() {
  return <App {...props} />;
}
